import * as Phaser from "phaser";

export class TextButton extends Phaser.GameObjects.Text {
  private originalScale: number = 1;
  private hoverScale: number = 1.1;
  private clickScale: number = 0.95;
  private originalColor: string = "#000000";
  private hoverColor: string = "#4a90e2";
  private isPressed: boolean = false;

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    text: string,
    callback: () => void,
    options?: {
      fontSize?: string;
      color?: string;
      hoverColor?: string;
      hoverScale?: number;
      clickScale?: number;
    },
  ) {
    const config = {
      fontSize: options?.fontSize || "20px",
      color: options?.color || "#000000",
      fontFamily: "Arial, sans-serif",
      backgroundColor: "#ffffff",
      padding: { x: 10, y: 5 },
      borderRadius: 5,
      stroke: "#000000",
      strokeThickness: 1,
    };

    super(scene, x, y, text, config);

    this.originalColor = options?.color || "#000000";
    this.hoverColor = options?.hoverColor || "#4a90e2";
    this.hoverScale = options?.hoverScale || 1.1;
    this.clickScale = options?.clickScale || 0.95;

    this.setInteractive({ useHandCursor: true });
    this.setOrigin(0.5);

    // Обработчики событий
    this.on("pointerover", this.onHover.bind(this));
    this.on("pointerout", this.onOut.bind(this));
    this.on("pointerdown", this.onDown.bind(this));
    this.on("pointerup", () => {
      this.onUp();
      callback();
    });
  }

  private onHover(): void {
    if (!this.isPressed) {
      this.scene.tweens.add({
        targets: this,
        scaleX: this.hoverScale,
        scaleY: this.hoverScale,
        duration: 150,
        ease: "Power2",
      });

      this.setColor(this.hoverColor);
    }
  }

  private onOut(): void {
    this.scene.tweens.add({
      targets: this,
      scaleX: this.originalScale,
      scaleY: this.originalScale,
      duration: 150,
      ease: "Power2",
    });

    this.setColor(this.originalColor);
  }

  private onDown(): void {
    this.isPressed = true;
    this.scene.tweens.add({
      targets: this,
      scaleX: this.clickScale,
      scaleY: this.clickScale,
      duration: 100,
      ease: "Power2",
    });
  }

  private onUp(): void {
    this.isPressed = false;
    this.scene.tweens.add({
      targets: this,
      scaleX: this.hoverScale,
      scaleY: this.hoverScale,
      duration: 100,
      ease: "Power2",
    });
  }

  // Метод для программного изменения состояния кнопки
  public setEnabled(enabled: boolean): void {
    this.setInteractive(enabled);
    if (!enabled) {
      this.setAlpha(0.5);
    } else {
      this.setAlpha(1);
    }
  }

  // Метод для изменения текста кнопки
  public setButtonText(text: string): void {
    this.setText(text);
  }
}
